export default __webpack_public_path__ + "static/media/EM1930.34I-42968_-25670_0.bcb5f1eb.jpg";